import { render, staticRenderFns } from "./IdentityAuditPage.vue?vue&type=template&id=0dc86caa&"
import script from "./IdentityAuditPage.vue?vue&type=script&lang=js&"
export * from "./IdentityAuditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports